















































































import { Component, Mixins, Prop, Watch } from "vue-property-decorator";
// Data
import {
  FILTER_OPERATORS,
  RELATIVE_DATE_OPERATORS,
  FilterTypes,
  FilterOperators
} from "@/data/table";
// Types
import { IFilter, IOperator } from "@/models/tables";
import HasValidation from "@/mixins/HasValidation";

@Component({
  components: {
    "select-operator": () =>
      import("@/components/app/global/dataFilters/selectOperator.vue"),
    "filter-input": () =>
      import("@/components/app/global/dataFilters/filterInput.vue")
  }
})
export default class FilterForm extends Mixins(HasValidation) {
  @Prop({ required: true })
  public filter!: IFilter;

  @Prop({ default: true })
  public showRelative!: boolean;

  public operators: IOperator[] = FILTER_OPERATORS();

  public localFilter: IFilter = {} as IFilter;
  public errorMessage = "Please enter valid value";

  public isSubmitted = false;
  public extraModalOpened = "";
  public relative = false;

  public created() {
    this.setLocalFilter();
  }

  public getFilterLabel() {
    return this.$_.get(this.filter, "label", "")
      .toString()
      .toLowerCase();
  }

  public get matchedOperators(): IOperator[] {
    if (!this.isDateFilter) {
      return this.$_.filter(this.operators, operator =>
        operator.types.includes(this.localFilter.type)
      );
    }
    const relativeCheck = (operator: IOperator) =>
      this.relative
        ? RELATIVE_DATE_OPERATORS.includes(operator.key)
        : !RELATIVE_DATE_OPERATORS.includes(operator.key);
    return this.$_.filter(
      this.operators,
      operator =>
        operator.types.includes(FilterTypes.DATE) && relativeCheck(operator)
    );
  }

  public get showOperatorSelect() {
    return this.matchedOperators.length > 1 && !this.isMonthFilter;
  }

  public get isDateFilter() {
    return this.localFilter.type === FilterTypes.DATE;
  }

  public get isMonthFilter() {
    return this.localFilter.type === FilterTypes.MONTH;
  }

  public get isSelectCheckboxFilter() {
    return this.localFilter.type === FilterTypes.SELECT_CHECKBOX;
  }

  public get isSelectRadioFilter() {
    return this.localFilter.type === FilterTypes.SELECT_RADIO;
  }

  public get isMultiSelectFilter() {
    return this.localFilter.type === FilterTypes.SELECT_MULTI;
  }

  public get isTagFilter() {
    return this.localFilter.type === FilterTypes.TAG;
  }

  public get isNotSetSelected() {
    return this.localFilter.operator === FilterOperators.NOT_SET;
  }

  @Watch("relative")
  public onRelativeChange() {
    this.localFilter.operator = this.matchedOperators[0].key;
    if (this.$_.some(this.matchedOperators, ["key", this.filter.operator])) {
      this.localFilter.operator = this.filter.operator;
    }
  }

  public get isValid(): boolean {
    return !this.$_.isEmpty(this.localFilter.value);
  }

  // computed
  public get showError(): boolean {
    return this.isSubmitted && !this.isValid;
  }

  public onSelectOperatorChange() {
    if (this.localFilter.operator === FilterOperators.NOT_SET)
      this.localFilter.value = "null";
  }

  public close(): void {
    this.$emit("close");
  }

  public applyFilter(): void {
    this.isSubmitted = true;
    if (this.isValid) {
      this.$emit("applyFilter", this.$_.cloneDeep(this.localFilter));
    }
  }

  public clickedOutside() {
    if (this.extraModalOpened === "closed") {
      this.extraModalOpened = "";
    } else if (this.extraModalOpened === "") {
      this.close();
    }
  }

  public onExtraModalOpened(isOpen: string) {
    this.extraModalOpened = isOpen;
  }

  public setInitialValue() {
    if (this.$_.has(this.localFilter, "value")) {
      if (
        this.isDateFilter &&
        RELATIVE_DATE_OPERATORS.includes(this.localFilter.operator)
      ) {
        this.relative = true;
      }

      return;
    }

    this.$set(this.localFilter, "value", "");
    if (this.isSelectRadioFilter) {
      this.localFilter.value = "0";
      return;
    }

    if (
      this.isSelectCheckboxFilter ||
      this.isTagFilter ||
      this.isMultiSelectFilter
    ) {
      this.localFilter.value = [];
      return;
    }

    if (this.isDateFilter) {
      // @ts-ignore
      this.localFilter.value = this.$moment();
      return;
    }

    this.localFilter.value = "";
  }

  public setOperator(filter: IFilter) {
    if (!this.$_.has(filter, "operator")) {
      const operator = this.$_.find(this.operators, o =>
        o.types.includes(filter.type)
      );
      if (operator !== undefined) {
        filter.operator = operator.key;
      }
    }

    return filter;
  }

  @Watch("filter", { deep: true })
  public setLocalFilter(): any {
    this.localFilter = this.setOperator(this.$_.cloneDeep(this.filter));
    this.setInitialValue();
  }
}
